import axios from "axios";

const apiUrl = "https://admin.utharamenon.com/api"; 
const API = axios.create();

// Prevent multiple guest token fetch requests
let isFetchingGuestToken = false;

// Attach token and handle request
API.interceptors.request.use(
  async (config) => {
    let authToken = localStorage.getItem("token");
    let guestToken = localStorage.getItem("guest_token");

    const parsedAuthToken = authToken ? JSON.parse(authToken) : null;

    // console.log("Sending Token:", parsedAuthToken || guestToken);

    if (parsedAuthToken) {
      config.headers.Authorization = `Bearer ${parsedAuthToken}`;
    } else if (guestToken) {
      config.headers.Authorization = `Bearer ${guestToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => {
    if (response.data.token) {
      // console.log("Refreshing Token:", response.data.token);
      localStorage.setItem("token", JSON.stringify(response.data.token));
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.error("Authorization error:", error.response);
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

// Function to fetch guest token
export const fetchGuestToken = async () => {
  if (isFetchingGuestToken) return;
  isFetchingGuestToken = true;

  try {
    // console.log("Fetching guest token...");
    const response = await axios.get(`${apiUrl}/guest-token`);
    
    // console.log("API Response:", response.data);

    const guestToken = response.data?.guest_token;
    if (guestToken) {
      localStorage.setItem("guest_token", guestToken);
      // console.log("Guest Token Stored in LocalStorage:", guestToken);
    } else {
      console.warn("Guest token not found in API response.");
    }
  } catch (error) {
    console.error("Error fetching guest token:", error);
  } finally {
    isFetchingGuestToken = false;
  }
};

// Ensure guest token exists before making API requests
if (!localStorage.getItem("guest_token")) {
  fetchGuestToken();
}

// API utility functions
export const GetAPI = async (url, callback) => {
  await API.get(apiUrl + url)
    .then((response) => callback(response.data))
    .catch((error) => console.error("GET API Error:", error));
};

export const PostAPI = async ({ url, data }, callback) => {
  await API.post(apiUrl + url, data)
    .then((response) => callback(response?.data))
    .catch((error) => callback(error?.response?.data));
};

export const PatchAPI = async ({ url, data }, callback) => {
  await API.patch(apiUrl + url, data)
    .then((response) => callback(response.data))
    .catch((error) => callback(error.response.data));
};

export const DeleteAPI = async ({ url, data }, callback) => {
  await API.delete(apiUrl + url, { data })
    .then((response) => callback(response.data))
    .catch((error) => callback(error.response.data));
};

export const PutAPI = async ({ url, data }, callback) => {
  await API.put(apiUrl + url, data)
    .then((response) => callback(response?.data))
    .catch((error) => {
      callback(error);
      console.error("PUT API Error:", error);
    });
};

export default API;
